import {AfterViewInit, Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FormsService} from '../shared/forms.service';

@Component({
  selector: 'app-user',
})
export abstract class UserGenericComponent {


  constructor(private formService: FormsService) {
  }


  public setValue(data: any) {
    this.getForm().patchValue(data);
  }

  public validateFormAndUpdateErrors(): boolean {
    return this.formService.validateFormAndUpdateErrors(this.getForm());
  }

  abstract getForm(): FormGroup;

  abstract submitForm(userInfo: any, id?: number);

}



// WEBPACK FOOTER //
// ./src/app/user/user-generic.component.ts